module.exports = __webpack_public_path__ + "img/Differentiation-CRC_10X_TGSP.d2ac78ee.png";